<template>
  <v-app>
    <v-app-bar
        app
        style="z-index:6;"
    >
      <v-app-bar-nav-icon
          @click="onClickToggleNavDrawer"
      />
      <v-toolbar-title class="text-uppercase">
        Jena handelt gemeinsam
      </v-toolbar-title>
      <v-spacer />
      <v-btn
          to="/about"
          icon
      >
        <v-icon>mdi-information-variant</v-icon>
      </v-btn>
      <template
          v-if="cShopListActive"
          #extension
      >
        <v-row
            dense
            align="baseline"
        >
          <v-col>
            <v-text-field
                label="Suche"
                clearable
                hide-details
                :value="cFilterValue.text"
                @input="onInputFilterText"
            />
          </v-col>
          <v-col>
            <gh-select-category
                multiple
                hide-details
                :value="cFilterValue.category"
                @input="onInputFilterCategory"
            />
          </v-col>
          <v-col>
            <gh-select-shipping
                hide-details
                :value="cFilterValue.shipping"
                @input="onInputFilterShipping"
            />
          </v-col>
        </v-row>
      </template>
    </v-app-bar>

    <gh-dialog-welcome
        v-model="welcomeDialog"
    />

    <v-content
        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 5;"
    >
      <router-view/>
    </v-content>

    <app-navigation-drawer />
  </v-app>
</template>

<script>

import GhDialogWelcome from '@/components/dialog/GhDialogWelcome'
import AppNavigationDrawer from '@/components/AppNavigationDrawer'
import {
  GhSelectCategory,
  GhSelectShipping
} from '@/components/input'

export default {
  name: 'App',
  components: {
    GhSelectShipping,
    GhSelectCategory,
    AppNavigationDrawer,
    GhDialogWelcome
  },
  computed : {
    cShopListActive () {
      return this.$route.name === 'list' || this.$route.name === 'shop'
    },
    cFilterValue () {
      return this.$store.getters['app/shopListFilter']
    }
  },
  data: () => ({
    welcomeDialog: false,
    filter: {
      text: '',
      category: [],
      shipping: null
    }
  }),
  created () {
    /*
    if (this.$localStorage.getItem('welcome-dialog-dismissed') !== 'true') {
      // the user has not dismissed the dialog so far
      this.welcomeDialog = true
      const unwatch = this.$watch('welcomeDialog', (newValue) => {
        // dialog has ben closed by the user
        if (!newValue) {
          // disable watch -> not needed anymore
          unwatch()

          // remember the user has seen the dialog
          this.$localStorage.setItem('welcome-dialog-dismissed', 'true')
        }
      })
    }
    */
  },
  methods: {
    onClickToggleNavDrawer () {
      this.toggleNavDrawer()
    },
    toggleNavDrawer () {
      this.$store.commit('app/toggleNavDrawer')
    },
    setFilter (filter) {
      this.$store.commit('app/setFilter', filter)
    },
    onInputFilterText (value) {
      if (value === null) value = ''
      this.setFilterValue('text', value)
    },
    onInputFilterCategory (value) {
      this.setFilterValue('category', value)
    },
    onInputFilterShipping (value) {
      this.setFilterValue('shipping', value)
    },
    setFilterValue (type, value) {
      const filter = JSON.parse(JSON.stringify(this.cFilterValue))

      filter[type] = value

      this.setFilter(filter)
    }
  }
};
</script>

<style>
  html, body {
    overflow: hidden;
  }
</style>
